// src/components/Dashboard.jsx
import { useEffect, useState } from "react";
import { db, collection, query, onSnapshot, orderBy } from "./firebase"; // Ajusta la ruta
import ConversationCard from "./ConversationCard";
import ChatPreviewItem from "./ChatPreviewItem";   // 👈 nuevo
import ChatWindow from "./ChatWindow";             // 👈 nuevo
// import { needAttention } from "./utils/chatHelpers";
import { needAttention as checkNeedAttention } from "./utils/chatHelpers"; // 👈 importa aquí


export default function Dashboard() {
    const [conversations, setConversations] = useState([]);
    // const [vertical, setVertical] = useState(false); // false = grid (como antes)
    const [selectedId, setSelectedId] = useState(
        conversations[0]?.id ?? null
    );
    // "grid"  = tarjetas como antes
    // "chat"  = modo plataforma agente
    const [view, setView] = useState("grid");

    const total = conversations.length;
    const botControl = conversations.filter((c) => !c.agentControl).length;
    const agentActive = total - botControl;


    // const awaiting = conversations.filter((c) => needAttention(c.historyChat)).length;
    const awaiting = conversations.filter((c) =>
        checkNeedAttention(c.historyChat, c.agentControl)
    ).length;


    const selectedConv = conversations.find((c) => c.id === selectedId);

    const toggleView = () =>
        setView((v) => (v === "grid" ? "chat" : "grid"));


    useEffect(() => {
        // Ordenar por lastUpdate en orden descendente (más reciente primero)
        const q = query(
            // collection(db, "activeUsersMayorista"),
            collection(db, "activeUsersConsumidorFinal"),
            orderBy("lastUpdate", "desc")
        );
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setConversations(data);
        });
        return () => unsubscribe();
    }, []);

    return (
        <>
            {/* Header con título + toggle */}
            <div className="flex items-center justify-between mb-4">
                <h1 className="text-2xl font-semibold">Conversaciones</h1>
                <button className="btn btn-sm" onClick={toggleView}>
                    {view === "grid" ? "Vista chat" : "Vista tarjetas"}
                </button>
            </div>
            {/* Métricas 100 % ancho */}
            <div className="stats shadow bg-base-100 w-full mb-4 ">
                <div className="stat flex-1">
                    <div className="stat-title">Total</div>
                    <div className="stat-value">{total}</div>
                </div>
                <div className="stat flex-1">
                    <div className="stat-title">Bot</div>
                    <div className="stat-value text-secondary">{botControl}</div>
                </div>
                <div className="stat flex-1">
                    <div className="stat-title">Agente</div>
                    <div className="stat-value text-success">{agentActive}</div>
                </div>
                <div className="stat flex-1">
                    <div className="stat-title">Necesitan&nbsp;atención</div>
                    <div className="stat-value text-warning">{awaiting}</div>
                </div>
            </div>

            {/* ───── VISTA GRID ORIGINAL ───── */}
            {view === "grid" && (
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {conversations.map((c) => (
                        <ConversationCard key={c.id} conversation={c} />
                    ))}
                </div>
            )}

            {/* ───── VISTA CHAT ───── */}
            {view === "chat" && (
                <div className="flex h-[80vh] shadow rounded-lg overflow-hidden">
                    {/* Columna izquierda: lista de previews */}
                    <aside className="w-72 border-r overflow-y-auto bg-base-200">
                        {/* <aside className="w-72 overflow-y-auto bg-base-100 border-r"> */}
                        {conversations.map((c) => (
                            <ChatPreviewItem
                                key={c.id}
                                conversation={c}
                                active={c.id === selectedId}
                                onClick={() => setSelectedId(c.id)}
                            />
                        ))}
                    </aside>

                    {/* Columna derecha: ventana de chat */}
                    <section className="flex-1 flex flex-col">
                        {selectedConv ? (
                            <ChatWindow conversation={selectedConv} />
                        ) : (
                            <div className="m-auto text-gray-500">
                                Selecciona un chat para comenzar
                            </div>
                        )}
                    </section>
                </div>
            )}
        </>
    );
}
